<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '信息费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      >
        <section slot="car" slot-scope="prop">
          <ChooseCar :isRadio="true" v-model="prop.form.car" @change="handleCarChange" />
        </section>
        <section slot="order" slot-scope="prop">
          <ChooseOrder
            :otherSearchData="{
              plateNumber: prop.form.car.plateNumber,
            }"
            :isRadio="true"
            v-model="prop.form.order"
            :clearable="true"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
import ChooseOrder from 'components/choose/order';
export default {
  components: {
    ChooseCar,
    ChooseOrder,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '申请金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入申请金额',
          },
          {
            label: '订单号码',
            value: 'order',
            slot: true,
            default: {},
            hide: true,
          },
          {
            label: '费用说明',
            value: 'payRemark',
            type: 'input',
            placeholder: '请输入费用说明',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: { // 表单验证规则
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          payAmt: [ // 申请金额
            { required: true, message: '请输入申请金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleCarChange (data) { // 车辆选择时
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: false,
        names: ['order'],
      });
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          item.order = {
            orderId: item.orderId,
          };
          this.$refs.customForm.setVal(item);
          this.handleCarChange();
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车牌号码
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;
      delete form.car;
      // 订单信息
      form.orderId = form.order.orderId ? String(form.order.orderId) : '';
      delete form.order;
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
